import { KeyframeConfig } from "../../../models/animations.model";

const SHOW_WITH_VISIBILITY_OFFSET = -5;

export const getHideWithOpacityKeyframe = (targets: any): KeyframeConfig[] => {
  return [
    {
      option: {
        keyframes: [
          { opacity: 0, duration: 1 },
          { opacity: 0, duration: 1 },
        ],
        targets,
      },
    },
  ];
};

export const getShowKeyframe = (
  targets: any,
  intialOpacity: number,
): KeyframeConfig[] => {
  return targets.flatMap((target: any) => {
    return [
      {
        option: {
          keyframes: [
            {
              duration: 0,
              opacity: intialOpacity,
            },
            {
              duration: 1,
              opacity: intialOpacity,
            },
          ],
          targets: target,
          begin: () => {
            target.set("visible", true);
          },
        },
        offset: SHOW_WITH_VISIBILITY_OFFSET,
      },
    ];
  });
};

export const getShowGroupObjectsBaseKeyframe = (
  group: fabric.Group,
  groupObjects: fabric.Object[],
  intialOpacity: number
): KeyframeConfig[] => {
  return groupObjects.flatMap((groupObject: any) => {
    return [
      {
        option: {
          keyframes: [
            {
              duration: 0,
              opacity: intialOpacity,
            },
            {
              duration: 1,
              opacity: intialOpacity,
            },
          ],
          targets: groupObject,
          begin: () => {
            const { left, top, width, height } = group;
            groupObject.set("visible", true);
            group.addWithUpdate();

            /**
             * Mandatory to do this, since addWithUpdate resets height
             * because the group elements were not rendered
             * and after they render it automatically fits the group height
             */
            group.set({ left, top, width, height });
          },
        },
        offset: SHOW_WITH_VISIBILITY_OFFSET,
      },
    ];
  });
};
